import { Helmet } from "react-helmet-async";
import useAppData from "../hooks/useAppData";

const TermsAndCondition = () => {
	const { termPage } = useAppData();
	return (
		<>
			<Helmet>
				<title>{termPage.meta_title}</title>
				<meta name="description" content={termPage.meta_description} />
				<meta name="keywords" content={termPage.meta_keywords} />
			</Helmet>
			<div>
				<div className="container">
					<div
						className="row py-5"
						dangerouslySetInnerHTML={{ __html: termPage.content }}
					></div>
				</div>
			</div>
		</>
	);
};

export default TermsAndCondition;
